import { createFileRoute, redirect } from '@tanstack/react-router'
import { requireRoles } from '@/lib/middleware'

// My Billables replaces this report. The role gate stays because the target has the
// same one, so nobody the target admits is stopped here.
export const Route = createFileRoute(
  '/_authenticated/_organization/reports/my-billable-hours'
)({
  beforeLoad: async () => {
    await requireRoles(['support_coordinator', 'admin'])
    throw redirect({ to: '/reports/my-billables', replace: true })
  },
})
